import { useEffect, useRef } from "react"

function usePrevious(value: any): any {
	const ref = useRef()
	useEffect(() => {
		ref.current = value
	})
	// eslint-disable-next-line react-hooks/refs
	return ref.current
}

export default usePrevious
